module.exports = __webpack_public_path__ + "img/shouhou.4c34a406.png";